import * as React from "react";

const SvgComponent = ({color = "#000000", width = "15px", height ="15px", onChange   , ...props}) => (
  <svg 
  width={width} height={height} 
  onClick={props.onClick}
  viewBox="0 0 15 15" fill="none"
  {...props}
  >
    <path
      d="m4.27 7.929 2.4 2.4 6.39-6.39-2.4-2.4-.004.003L4.27 7.93ZM3.718 8.505l-.002.006-.003-.002-.986 3.366 3.366-.987-.003-.002.007-.002-2.38-2.38ZM14.201.878l-.48-.48c-.53-.53-1.39-.53-1.92 0l-.574.574 2.4 2.4.57-.57.004-.004c.53-.53.53-1.39 0-1.92Z"
      fill={color}
    />
    <path
      d="M12.534 13.097H1.65V2.212H8.79L9.84 1.164H.602v12.981h12.98v-9.53l-1.047 1.05v7.432Z"
      fill={color}
    />
  </svg>
);

export default SvgComponent;
